import BaseComponent from '../BaseComponent';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import VenueSearchV2 from '../VenueSearchV2';

const NAME = 'VenueDetailsEdit';

const SELECTOR_PAGE = '.lta-venue-details-edit';
const SELECTOR_TRIGGER_EXIT_BUTTON = '.js-exit-match-venue-edit-modal';
const SELECTOR_TRIGGER_CANCEL_BUTTON = '.js-cancel-venue-details-edit-modal';
const SELECTOR_TRIGGER_SAVE_BUTTON = '.js-save-venue-details-edit-modal';

const EVENT_CLICK = `click`;

class VenueDetailsEdit extends BaseComponent {

	constructor(element) {
		super(element);
		this._saveCallbacks = [];
		this._cancelCallbacks = [];
		this.venueSearchEl = undefined;
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		this._wrapperElement = SelectorEngine.findOne(SELECTOR_PAGE);

		if (!this._wrapperElement) {
			return;
		}

		this._venueDetailsModalExitButton = SelectorEngine.findOne(SELECTOR_TRIGGER_EXIT_BUTTON, this._wrapperElement);
		this._venueDetailsModalCancelButton = SelectorEngine.findOne(SELECTOR_TRIGGER_CANCEL_BUTTON, this._wrapperElement);

		this._venueDetailsModalsaveButton = SelectorEngine.findOne(SELECTOR_TRIGGER_SAVE_BUTTON, this._wrapperElement);
		
		EventHandler.on(this._venueDetailsModalExitButton, EVENT_CLICK , this.onCancelClickHandler.bind(this));
		EventHandler.on(this._venueDetailsModalCancelButton, EVENT_CLICK , this.onCancelClickHandler.bind(this));

		EventHandler.on(this._venueDetailsModalsaveButton, EVENT_CLICK , this.onSaveClickHandler.bind(this));
		this.venueSearchEl = VenueSearchV2.getInstance(document.querySelector('.js-venue-search-v2')) || new VenueSearchV2(document.querySelector('.js-venue-search-v2'));
	}

	onCancel(callback){
		this._cancelCallbacks.push(callback);
	}

	onCancelClickHandler(){
		for (const callback of this._cancelCallbacks) {
			callback();
		}
	}

	onSave(callback) {
		this._saveCallbacks.push(callback);
	}

	onSaveClickHandler() {
		let venueData = this.venueSearchEl.state.venues;
		if(venueData.length > 0) {
			document.getElementById('venueid_updated').value = venueData[0].id;
			for (const callback of this._saveCallbacks) {
				callback(venueData);
			}
			document.getElementById('confirm-result').classList.add('u-hidden');
			document.getElementById('dispute-result').classList.remove('u-hidden');
		}
	}
}

export default VenueDetailsEdit;
